var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCouponLineFinance = function SvgCouponLineFinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 3.333A.833.833 0 0 1 2.5 2.5h15a.833.833 0 0 1 .834.833v4.584a2.083 2.083 0 1 0 0 4.166v4.584a.833.833 0 0 1-.834.833h-15a.833.833 0 0 1-.833-.833V3.333Zm5.07 12.5a1.25 1.25 0 0 1 2.36 0h7.57V13.36a3.75 3.75 0 0 1 0-6.72V4.167h-7.57a1.25 1.25 0 0 1-2.36 0H3.335v11.666h3.404Zm1.18-6.666a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm0 4.166a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z",
    fill: "#F2A72D"
  })));
};
export default SvgCouponLineFinance;